import React, { Component } from 'react'
import { render } from 'react-dom'
import Keen from 'keen-js'
import { object, string } from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'

// utils
import { createQuery, runQuery, createQueryCTA } from '../../../utils/KeenReport'
import numeral from '../../../utils/numeral'

// components
import Spinner from '../../Spinner'

// c3
import C3Chart from 'react-c3js'
import 'c3/c3.css'

class DailyFunnelChart extends Component {
  constructor (props) {
    super(props)

    let uniqueId
    if (this.props.video) {
      uniqueId = 'dailychartwithlinks' + this.props.video.id + this.props.actor
    } else {
      uniqueId = 'dailychartwithlinks' + this.props.campaign.id + this.props.actor
    }

    this.state = {
      isLoading: true,
      isEmpty: false,
      hasError: false,
      uniqueId: uniqueId,
      data: {}
    }

    this.runKeen = this.runKeen.bind(this)
    this.isFullOfEmptyValues = this.isFullOfEmptyValues.bind(this)
  }
  componentDidMount () {
    this.runKeen(this.props)
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.timeframe !== this.props.timeframe) {
      this.runKeen(nextProps)
    }
  }
  isFullOfEmptyValues (array) {
    return array.every((value) => {
      return !(value > 0)
    })
  }
  isSameDay (timeframe) {
    let timeDiff = moment(timeframe.start).diff(moment(timeframe.end), 'days')
    return !timeDiff
  }
  runKeen (props) {
    Keen.ready(() => {
      let { campaign, actor, timeframe, video, filters } = props
      let queries
      this.setState({
        isLoading: true,
        hasError: false,
        isEmpty: false
      })
      let time = 'daily'
      if (this.isSameDay(timeframe)) {
        time = 'hourly'
      }
      if (actor === 'pessoas') {
        queries = [
          createQuery('count_unique', 'video_recomended', timeframe, campaign, video, 'client_viewer_id', time, filters),
          createQuery('count_unique', 'video_unique_click', timeframe, campaign, video, 'client_viewer_id', time, filters)
        ]
        if (video && video.conversion_filter && video.conversion_filter.length > 0) {
          queries.push(
            createQueryCTA('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', time, [...video.conversion_filter, ...filters])
          )
        } else {
          queries.push(createQuery('count', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, filters))
        }
        queries.push(createQuery('count_unique', 'link_requested', timeframe, campaign, video, 'client_viewer_id', time, filters))
        queries.push(createQuery('count_unique', 'link_responded', timeframe, campaign, video, 'client_viewer_id', time, filters))
        queries.push(createQuery('count_unique', 'url_expanded', timeframe, campaign, video, 'viewer_id', time, filters))
      } else {
        queries = [
          createQuery('count', 'video_recomended', timeframe, campaign, video, null, time, filters),
          createQuery('count', 'video_unique_click', timeframe, campaign, video, null, time, filters)
        ]
        if (video && video.conversion_filter && video.conversion_filter.length > 0) {
          queries.push(
            createQueryCTA('count', 'user_interacted', timeframe, campaign, video, null, time, [...video.conversion_filter, ...filters])
          )
        } else {
          queries.push(createQuery('count', 'user_interacted', timeframe, campaign, video, null, null, filters))
        }
        queries.push(createQuery('count', 'link_requested', timeframe, campaign, video, null, time, filters))
        queries.push(createQuery('count', 'link_responded', timeframe, campaign, video, null, time, filters))
        queries.push(createQuery('count', 'url_expanded', timeframe, campaign, video, null, time, filters))
      }
      runQuery(queries)
        .then((res) => {
          let columnx
          if (time === 'hourly') {
            columnx = res[0].result.reduce((initial, current) => {
              let date = moment(current.timeframe.start).format('HH:mm')
              initial.push(date)
              return initial
            }, ['x'])
          } else {
            columnx = res[0].result.reduce((initial, current) => {
              let date = moment(current.timeframe.start).format('DD/MM')
              initial.push(date)
              return initial
            }, ['x'])
          }
          let column1 = res[0].result.reduce((initial, current) => {
            initial.push(current.value)
            return initial
          }, ['Visitas'])
          let column2 = res[1].result.reduce((initial, current) => {
            initial.push(current.value)
            return initial
          }, ['Plays'])
          var columns = [columnx, column1, column2]
          var axes = {
            'Visitas': 'y',
            'Plays': 'y'
          }
          if (res[2]) {
            var column4 = res[2].result.reduce((initial, current) => {
              initial.push(current.value)
              return initial
            }, ['Conversões'])
            columns = [columnx, column1, column2, column4]
            axes = {
              'Links/SMS solicitados': 'y',
              'Links/SMS enviados': 'y',
              'Cliques': 'y',
              'Visitas': 'y',
              'Plays': 'y',
              'Conversões': 'y'
            }
          }
          let columnLinksRequested = res[3].result.reduce((initial, current) => {
            initial.push(current.value)
            return initial
          }, ['Links/SMS solicitados'])
          columns.push(columnLinksRequested)
          let columnLinksResponded = res[4].result.reduce((initial, current) => {
            initial.push(current.value)
            return initial
          }, ['Links/SMS enviados'])
          columns.push(columnLinksResponded)
          let columnLinksClicked = res[5].result.reduce((initial, current) => {
            initial.push(current.value)
            return initial
          }, ['Cliques'])
          columns.push(columnLinksClicked)
          let data = {
            x: 'x',
            columns: columns,
            axes: axes
          }
          let axis = {
            x: {
              type: 'category',
              tick: {
                culling: {
                  max: 4
                },
                multiline: false
              }
            },
            y: {
              label: {
                text: '',
                position: 'outer-middle'
              },
              tick: {
                format: function (value) {
                  return numeral(value).format('0,0[.]00')
                }
              }
            },
            y2: {
              show: false,
              label: {
                position: 'outer-middle'
              },
              tick: {
                format: function (value) {
                  return numeral(value).format('0[.]000%')
                }
              }
            }
          }
          let tooltip = {
            format: {
              value: function (value, ratio, id, index) {
                if (id === 'Play Rate' || id === 'CTA Click Rate') {
                  return numeral(value).format('0[.]000%')
                } else {
                  return numeral(value).format('0,0[.]00')
                }
              }
            }
          }
          if (
            this.isFullOfEmptyValues(column1) &&
            this.isFullOfEmptyValues(column2)
          ) {
            this.setState({
              isLoading: false,
              hasError: false,
              isEmpty: true
            })
          } else {
            this.setState({
              isLoading: false,
              hasError: false,
              isEmpty: false
            })
            const mountNode = document.getElementById(this.state.uniqueId)
            const chart = <C3Chart data={data} axis={axis} tooltip={tooltip} />
            render(chart, mountNode)
          }
        }, (err) => {
          console.log('Erro rodando a query do Keen.', err)
          this.setState({
            hasError: true
          })
        })
    })
  }
  render () {
    let { uniqueId, isLoading, hasError, isEmpty } = this.state
    return (
      <div>
        <div className={classNames({ 'hidden': isLoading || isEmpty })}>
          <div id={uniqueId} />
        </div>
        <Spinner isLoading={isLoading} hasError={hasError} isEmpty={isEmpty} runKeen={() => { this.runKeen(this.props) }} />
      </div>
    )
  }
}

DailyFunnelChart.propTypes = {
  timeframe: object,
  campaign: object,
  actor: string,
  video: object
}

export default DailyFunnelChart



// WEBPACK FOOTER //
// ./src/components/charts/DailyFunnels/DailyFunnelChartWithLinks.js